import { createFileRoute, Link } from "@tanstack/react-router";
import { saMenuGroups } from "@/lib/sa-menu";
import { Card } from "@/components/ui/card";

export const Route = createFileRoute("/_authenticated/sa/")({
  head: () => ({ meta: [{ title: "Administração do Sistema — FutBux" }] }),
  component: SaHome,
});

function SaHome() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Administração do Sistema</h1>
        <p className="text-muted-foreground">Gestão global do FutBux: assinaturas, centros e finanças.</p>
      </div>
      {saMenuGroups.map((group) => (
        <section key={group.label} className="space-y-3">
          <h2 className="text-sm font-semibold uppercase text-muted-foreground">{group.label}</h2>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <Link key={item.slug} to="/sa/$slug" params={{ slug: item.slug }}>
                  <Card className="p-4 flex items-center gap-3 hover:border-primary transition-colors">
                    <Icon className="h-6 w-6 text-primary" />
                    <span className="font-medium">{item.title}</span>
                  </Card>
                </Link>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
